export const maskEmail = (email) => {
  if (!email) {
    return 'N/A'
  }

  try {
    const [username, domain] = email.split('@')

    if (username?.length >= 8) {
      const first4 = username.slice(0, 4)
      const last4 = username.slice(-4)

      return `${first4}***${last4}@${domain}`
    }

    const first3 = username?.slice(0, 3)

    return `${first3}***@${domain}`
  } catch (error) {
    return 'N/A'
  }
}

export const maskPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) {
    return 'N/A'
  }

  try {
    const first3 = phoneNumber.slice(0, 3)
    const last4 = phoneNumber.slice(-4)

    return `${first3}***${last4}`
  } catch (error) {
    return 'N/A'
  }
}
